<template>
  <div class="stock-trend-query">
    <div class="page-header">
      <div class="page-title">
        <div class="title-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12L7 8M3 12L7 16M3 12H13M13 4L21 4M13 12L21 12M13 20L21 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h1>股票趋势分析</h1>
        <div class="title-decoration"></div>
      </div>
      <p class="page-subtitle">基于移动平均线的智能趋势识别系统</p>
    </div>

    <div class="filter-bar">
      <el-select
        v-model="selectedTrend"
        placeholder="请选择趋势状态"
        clearable
        class="filter-select"
      >
        <el-option label="强势上涨" value="强势上涨"></el-option>
        <el-option label="近期上涨" value="近期上涨"></el-option>
        <el-option label="持续上涨" value="持续上涨"></el-option>
        <el-option label="强势下跌" value="强势下跌"></el-option>
        <el-option label="近期下跌" value="近期下跌"></el-option>
        <el-option label="持续下跌" value="持续下跌"></el-option>
        <el-option label="震荡" value="震荡"></el-option>
      </el-select>

      <el-select
        v-model="searchCode"
        placeholder="股票代码（可选）"
        filterable
        clearable
        class="search-select"
        :loading="stockListLoading"
      >
        <el-option
          v-for="item in stockCodeList"
          :key="item.stock_code"
          :label="`${item.stock_name} (${item.stock_code})`"
          :value="item.stock_code"
        >
        </el-option>
      </el-select>

      <el-date-picker
        v-model="selectedDate"
        type="date"
        placeholder="选择统计日期"
        value-format="yyyy-MM-dd"
        class="date-picker"
      >
      </el-date-picker>

      <el-button type="primary" @click="fetchData" :loading="loading">查询</el-button>
      <el-button @click="resetFilters">重置</el-button>
    </div>

    <div class="stock-count">共找到 <strong>{{ stockList.length }}</strong> 只股票</div>

    <el-table
      :data="paginatedStockList"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      class="stock-table"
    >
      <el-table-column prop="code" label="股票代码" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="viewKLine(scope.row, 'day')">
            {{ scope.row.code }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="stock_name" label="股票名称" width="150">
        <template slot-scope="scope">
          {{ scope.row.stock_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="stat_date" label="统计日期" width="120">
      </el-table-column>
      <el-table-column prop="close" label="收盘价" width="100">
        <template slot-scope="scope">
          {{ scope.row.close ? parseFloat(scope.row.close).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="ma5" label="MA5" width="100">
        <template slot-scope="scope">
          {{ scope.row.ma5 ? parseFloat(scope.row.ma5).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="ma10" label="MA10" width="100">
        <template slot-scope="scope">
          {{ scope.row.ma10 ? parseFloat(scope.row.ma10).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="ma20" label="MA20" width="100">
        <template slot-scope="scope">
          {{ scope.row.ma20 ? parseFloat(scope.row.ma20).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="ma60" label="MA60" width="100">
        <template slot-scope="scope">
          {{ scope.row.ma60 ? parseFloat(scope.row.ma60).toFixed(2) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="trend" label="趋势状态" width="120">
        <template slot-scope="scope">
          <el-tag
            :type="getTrendTagType(scope.row.trend)"
            effect="dark"
          >
            {{ scope.row.trend || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'day')"
          >
            日K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'week')"
          >
            周K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, '5min')"
          >
            5分
          </el-button>
          <el-button
            type="text"
            size="small"
            :loading="scope.row.adding"
            @click.stop="addToFavorite(scope.row)"
          >
            自选
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="stockList.length"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StockTrendQuery',
  data() {
    return {
      loading: false,
      stockList: [],
      stockCodeList: [],
      stockListLoading: false,
      selectedTrend: '',
      searchCode: '',
      selectedDate: '',
      currentPage: 1,
      pageSize: 50,
      userId: '1'
    }
  },
  computed: {
    paginatedStockList() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.stockList.slice(start, end)
    }
  },
  mounted() {
    // 设置默认日期为今天
    // this.selectedDate = this.formatDate(new Date())
    this.selectedDate = '2026-03-06'
    // 加载股票列表
    this.fetchStockList()
  },
  methods: {
    // 获取股票列表
    async fetchStockList() {
      this.stockListLoading = true
      try {
        const response = await axios.get('/stock/info/list')
        if (response.data.status === 'success' && response.data.data) {
          this.stockCodeList = response.data.data
        } else {
          this.stockCodeList = []
        }
      } catch (error) {
        console.error('获取股票列表失败:', error)
        this.stockCodeList = []
      } finally {
        this.stockListLoading = false
      }
    },

    // 获取数据
    async fetchData() {
      // if (!this.selectedTrend) {
      //   this.$message.warning('请选择趋势状态')
      //   return
      // }

      this.loading = true
      try {
        const params = {
          trend: this.selectedTrend
        }
        if (this.searchCode) {
          params.code = this.searchCode
        }
        if (this.selectedDate) {
          params.stat_date = this.selectedDate
        }

        console.log('请求参数:', params)
        const response = await axios.get('/stock/trend/ma/query', { params })
        console.log('趋势查询接口返回:', response.data)

        if (response.data.status === 'success' && response.data.data) {
          this.stockList = response.data.data
          this.currentPage = 1
          this.$message.success(`查询成功，共找到 ${this.stockList.length} 只股票`)
        } else {
          this.stockList = []
          this.$message.warning('未找到符合条件的股票')
        }
      } catch (error) {
        console.error('查询失败:', error)
        this.$message.error('查询失败: ' + (error.response?.data?.message || error.message))
        this.stockList = []
      } finally {
        this.loading = false
      }
    },

    // 重置筛选
    resetFilters() {
      this.selectedTrend = ''
      this.searchCode = ''
      this.selectedDate = this.formatDate(new Date())
      this.stockList = []
      this.currentPage = 1
    },

    // 查看K线
    viewKLine(row, type) {
      const routeMap = {
        'day': '/kline/day',
        'week': '/kline/week',
        '5min': '/kline/5min'
      }
      this.$router.push({
        path: routeMap[type],
        query: { code: row.code }
      })
    },

    // 添加到自选
    async addToFavorite(row) {
      this.$set(row, 'adding', true)
      try {
        const response = await axios.post('/stock/favorite/add', {
          user_id: this.userId,
          stock_code: row.code,
          stock_name: row.stock_name || row.code,
          remark: '',
          sort_order: 0
        })
        if (response.data.status === 'success') {
          this.$message.success(`已将 ${row.stock_name || row.code} 添加到自选`)
        } else {
          this.$message.error(response.data.message || '添加失败')
        }
      } catch (error) {
        console.error('添加自选失败:', error)
        this.$message.error('添加自选失败: ' + (error.response?.data?.message || error.message))
      } finally {
        this.$set(row, 'adding', false)
      }
    },

    // 获取趋势标签类型
    getTrendTagType(trend) {
      if (!trend) return 'info'
      if (trend.includes('上涨')) {
        return trend.includes('强势') ? 'danger' : 'warning'
      } else if (trend.includes('下跌')) {
        return trend.includes('强势') ? 'success' : 'primary'
      }
      return 'info'
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.stock-trend-query {
  padding: 20px;
  min-height: calc(100vh - 40px);
  background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0d1229 100%);
  position: relative;
  overflow: hidden;
}

.stock-trend-query::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.08) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(99, 102, 241, 0.06) 0%, transparent 50%);
  animation: bg-pulse 15s ease-in-out infinite;
  pointer-events: none;
}

@keyframes bg-pulse {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-2%, -2%) scale(1.02); }
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.3);
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.15);
}

.title-icon svg {
  width: 24px;
  height: 24px;
}

.page-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #a5b4fc 0%, #c4b5fd 50%, #a5b4fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.title-decoration {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #6366f1 50%, transparent 100%);
  border-radius: 2px;
}

.page-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  position: relative;
  z-index: 1;
}

.filter-select {
  width: 180px;
}

.search-select {
  width: 250px;
}

.filter-select :deep(.el-input__inner),
.search-select :deep(.el-input__inner),
.date-picker :deep(.el-input__inner),
.filter-bar :deep(.el-date-editor .el-input__inner) {
  background: rgba(15, 23, 42, 0.6) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  color: #e2e8f0 !important;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.filter-select :deep(.el-input__inner):hover,
.search-select :deep(.el-input__inner):hover,
.date-picker :deep(.el-input__inner):hover,
.filter-bar :deep(.el-date-editor .el-input__inner):hover {
  border-color: rgba(99, 102, 241, 0.4) !important;
  box-shadow: 0 0 12px rgba(99, 102, 241, 0.15) !important;
}

.filter-select :deep(.el-input__inner):focus,
.search-select :deep(.el-input__inner):focus,
.date-picker :deep(.el-input__inner):focus,
.filter-bar :deep(.el-date-editor .el-input__inner):focus {
  border-color: #6366f1 !important;
  box-shadow: 0 0 16px rgba(99, 102, 241, 0.25) !important;
}

.filter-select :deep(.el-input__inner)::placeholder,
.search-select :deep(.el-input__inner)::placeholder {
  color: rgba(226, 232, 240, 0.4);
}

.date-picker {
  width: 180px;
}

.date-picker :deep(.el-input__prefix),
.filter-bar :deep(.el-date-editor .el-input__prefix) {
  color: rgba(99, 102, 241, 0.6) !important;
}

.date-picker :deep(.el-input__icon),
.filter-bar :deep(.el-date-editor .el-input__icon) {
  color: rgba(99, 102, 241, 0.6) !important;
}

.filter-bar :deep(.el-button--primary) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
  transition: all 0.3s ease;
}

.filter-bar :deep(.el-button--primary):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(99, 102, 241, 0.45);
}

.filter-bar :deep(.el-button--primary):active {
  transform: translateY(0);
}

.filter-bar :deep(.el-button--default) {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 24px;
  color: #cbd5e1;
  transition: all 0.3s ease;
}

.filter-bar :deep(.el-button--default):hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #e2e8f0;
}

.stock-count {
  margin-bottom: 16px;
  color: #94a3b8;
  font-size: 14px;
  padding: 10px 16px;
  background: rgba(99, 102, 241, 0.08);
  border-radius: 8px;
  border-left: 3px solid #6366f1;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.stock-count strong {
  color: #a5b4fc;
  font-weight: 600;
}

.stock-table {
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.stock-table :deep(.el-table__header-wrapper) {
  background: linear-gradient(180deg, rgba(30, 41, 59, 0.9) 0%, rgba(15, 23, 42, 0.9) 100%);
}

.stock-table :deep(.el-table__header th) {
  background: transparent;
  color: #cbd5e1;
  font-weight: 600;
  border-bottom: 1px solid rgba(99, 102, 241, 0.2);
  padding: 14px 0;
}

.stock-table :deep(.el-table__body) {
  background: rgba(15, 23, 42, 0.5);
}

.stock-table :deep(.el-table__body tr) {
  background: transparent;
  transition: all 0.25s ease;
}

.stock-table :deep(.el-table__body tbody tr:hover > td) {
  background: rgba(99, 102, 241, 0.08) !important;
}

.stock-table :deep(.el-table__body td) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  color: #e2e8f0;
  padding: 12px 0;
}

.stock-table :deep(.el-table__body-wrapper) {
  background: rgba(15, 23, 42, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0 0 12px 12px;
}

.stock-table :deep(.el-button--text) {
  color: #a5b4fc;
  transition: all 0.2s ease;
}

.stock-table :deep(.el-button--text:hover) {
  color: #c7d2fe;
  text-shadow: 0 0 8px rgba(165, 180, 252, 0.4);
}

.stock-table :deep(.el-tag) {
  border: none;
  padding: 5px 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
}

.pagination :deep(.el-pagination) {
  color: #94a3b8;
}

.pagination :deep(.el-pagination .el-pager li) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  margin: 0 4px;
  min-width: 32px;
  height: 32px;
  line-height: 30px;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination .el-pager li:hover) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}

.pagination :deep(.el-pagination .el-pager li.active) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-color: transparent;
  color: #ffffff;
  font-weight: 600;
}

.pagination :deep(.el-pagination button) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #94a3b8;
  transition: all 0.25s ease;
}

.pagination :deep(.el-pagination button:hover) {
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}

.pagination :deep(.el-pagination .el-pagination__sizes .el-select .el-input .el-input__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border-radius: 6px;
}

.pagination :deep(.el-pagination .el-pagination__jump) {
  color: #94a3b8;
}

/* 下拉选项样式 */
.filter-select :deep(.el-select-dropdown),
.search-select :deep(.el-select-dropdown),
.date-picker :deep(.el-picker-panel) {
  background: rgba(15, 23, 42, 0.95) !important;
  border: 1px solid rgba(99, 102, 241, 0.2) !important;
  backdrop-filter: blur(20px);
}

.filter-select :deep(.el-select-dropdown__item),
.search-select :deep(.el-select-dropdown__item) {
  color: #e2e8f0 !important;
}

.filter-select :deep(.el-select-dropdown__item:hover),
.search-select :deep(.el-select-dropdown__item:hover) {
  background: rgba(99, 102, 241, 0.15) !important;
}

.filter-select :deep(.el-select-dropdown__item.selected),
.search-select :deep(.el-select-dropdown__item.selected) {
  color: #a5b4fc !important;
  background: rgba(99, 102, 241, 0.1) !important;
}
</style>
